import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from '../services/monitoring/monitoring.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
	constructor(private monitoringService: MonitoringService) {}

	handleError(error: any): void {
		console.log('🚀 ~ CustomErrorHandler ~ handleError ~ error:', error);
		if (error && error.message && error.message.indexOf('ChunkLoadError') && !error.message.indexOf('OverconstrainedError') ) {
			this.monitoringService.captureError(error, {
				type: 'ChunkLoadError',
				locatedAt: 'CustomErrorHandler',
			}
		);
			// TODO: Se deja temporalmente En DEV y QA así para debuguear mejor en pruebas
			// window.location.reload();
			return;
		}

		this.monitoringService.captureError(error, {
			locatedAt: 'CustomErrorHandler',
		});
	}
}
